<template>
  <div :class="['gpt-page', { 'chat-active': hasStartedChat }]">
    <div class="content-wrap">
      <div class="header">
        <h2>Цифровой аналитик MediaHills</h2>
        <div class="header-subtitle">
          👉 Вы можете задать вопрос по вашему каналу или выбрать один из примеров
        </div>
      </div>

      <div v-if="!hasStartedChat" class="intro">
        <div class="prompt-cards">
          <div
            v-for="prompt in prompts"
            :key="prompt"
            class="prompt-card"
            @click="setPrompt(prompt)"
          >
            {{ prompt }}
          </div>
        </div>

        <div class="intro-title">Задайте вопрос по вашему каналу</div>

        <div class="composer welcome-composer ml-4">
          <div class="row">
            <input
              ref="inputTop"
              v-model.trim="inputTop"
              type="text"
              placeholder="Введите сообщение..."
              @keydown.enter="send()"
            >
            <button :disabled="isBusy" @click="send()">Отправить</button>
          </div>
        </div>
      </div>

      <div v-if="hasStartedChat" ref="chat" class="chat">
        <div class="chat-inner">
          <div
            v-for="(message, index) in messages"
            :key="message.id || index"
            :class="['msg', message.role === 'user' ? 'user-msg' : 'assistant-msg']"
          >
            <div v-if="message.role === 'user'" class="user-bubble">
              {{ message.text }}
            </div>

            <div v-else class="assistant-content">              
              <div
                v-for="(block, blockIndex) in message.blocks"
                :key="`${index}-${blockIndex}`"
                v-html="block"
              />
            </div>
          </div>
        </div>
        <div v-if="isBusy" class="typing">Анализирую данные и подготавливаю ответ...</div>
      </div>

      <div v-if="hasStartedChat" class="composer chat-composer">
        <div class="row">
          <input
            ref="inputBottom"
            v-model.trim="inputBottom"
            type="text"
            placeholder="Введите сообщение..."
            @keydown.enter="send()"
          >
          <button :disabled="isBusy" @click="send()">Отправить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { CONSTS } from "../services/constants.js";

export default {
  name: "Help",
  data() {
    return {
      inputTop: "",
      inputBottom: "",
      hasStartedChat: false,
      isBusy: false,
      messages: [],
      nextMessageId: 1,
      prompts: [
        "Почему падает аудитория при смене передачи?",
        "Что важнее — контент или соответствие слоту?",
        "Сколько каналов обычно смотрит один зритель?",
        "Как понять, какого контента не хватает в сетке?",
        "Как правильно анализировать свой канал?",
      ],
      apiUrl: process.env.VUE_APP_API_URL+ "gpt",
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.inputTop) {
        this.$refs.inputTop.focus();
      }
    });
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    appName() {
      return process.env.VUE_APP_APP_NAME;
    },
    majorVersion() {
      return CONSTS.MAJOR_VERSION;
    },
    currentYear() {
      return moment().format("YYYY");
    },
    frontVersion() {
      return process.env.VUE_APP_FRONT_VER;
    },
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    getActiveInputModel() {
      return this.hasStartedChat ? this.inputBottom : this.inputTop;
    },
    setActiveInputModel(value) {
      if (this.hasStartedChat) {
        this.inputBottom = value;
      } else {
        this.inputTop = value;
      }
    },
    setPrompt(prompt) {
      this.setActiveInputModel(prompt);
      this.$nextTick(() => {
        const refName = this.hasStartedChat ? "inputBottom" : "inputTop";
        if (this.$refs[refName]) {
          this.$refs[refName].focus();
        }
      });
    },
    activateChatMode() {
      if (this.hasStartedChat) return;

      this.hasStartedChat = true;
      this.inputBottom = "";

      this.$nextTick(() => {
        this.scrollPageToBottom();
      });
    },
    scrollPageToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    },
    splitHtmlToBlocks(html) {
      const wrapper = document.createElement("div");
      wrapper.innerHTML = html;
      const blocks = [];

      Array.from(wrapper.children).forEach((node) => {
        blocks.push(node.outerHTML);
      });

      return blocks;
    },
    escapeHtml(text) {
      const div = document.createElement("div");
      div.textContent = text;
      return div.innerHTML;
    },
    formatResponseText(responseText) {
        const html = (responseText || "").trim();

        if (!html) {
          return "<p>Пустой ответ от сервера.</p>";
        }

        const hasHtmlTags = html.indexOf("<") !== -1 && html.indexOf(">") !== -1;

        if (hasHtmlTags) {
          return html;
        }

        const parts = html
          .split("\n\n")
          .map((item) => item.trim())
          .filter(Boolean);

        if (!parts.length) {
          return "<p>Пустой ответ от сервера.</p>";
        }

        return parts
          .map((part) => {
            const formattedPart = part.split("\n").join("<br>");
            return `<p>${formattedPart}</p>`;
          })
          .join("");
      },
    async fetchResponseText_(prompt) {
      const response = await fetch(this.apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ prompt }),
      });

      if (!response.ok) {
        throw new Error(`Ошибка сервера: ${response.status}`);
      }

      const data = await response.text();
      return data
      //return data && typeof data.responseText === "string" ? data.responseText : "";
    },
    async fetchResponseText(prompt) {
      const that = this;
      let response 
      const CancelToken = axios.CancelToken;
      try {
        response = await axios.post("gpt", JSON.stringify({ prompt }), {
          cancelToken: new CancelToken(function executor(c) {
            that.axiosCancel = c;
          }),
        });
      } catch (e) {
        throw new Error(`Ошибка сервера..`);
      }

      return response.data.html_response;
    },
    async send(textFromCaller = null) {
      const text = (textFromCaller !== null ? textFromCaller : this.getActiveInputModel()).trim();

      if (!text || this.isBusy) return;

      if (!this.hasStartedChat) {
        this.activateChatMode();
      }

      this.isBusy = true;
      this.messages.push({
        id: this.nextMessageId++,
        role: "user",
        text,
      });
      this.inputTop = "";
      this.inputBottom = "";

      this.scrollPageToBottom();

      const assistantMessage = {
        id: this.nextMessageId++,
        role: "assistant",
        typing: true,
        blocks: [],
      };
      this.messages.push(assistantMessage);

      this.$forceUpdate();
      this.scrollPageToBottom();

      await this.sleep(450);
      assistantMessage.typing = false;
      this.$forceUpdate();

      let responseText = "";

      try {
        responseText = await this.fetchResponseText(text);
      } catch (error) {
        responseText = error && error.message
          ? `Не удалось получить ответ от сервера. ${error.message}`
          : "Не удалось получить ответ от сервера.";
      }

      const responseHtml = this.formatResponseText(responseText);
      const blocks = this.splitHtmlToBlocks(responseHtml);
      this.isBusy = false;
      for (const block of blocks) {
        assistantMessage.blocks.push(block);
        this.$forceUpdate();
        this.scrollPageToBottom();
        await this.sleep(500);
      }

      this.$nextTick(() => {
        if (this.$refs.inputBottom) {
          this.$refs.inputBottom.focus();
        }
        this.scrollPageToBottom();
      });
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.gpt-page {
  width: 100%;
  min-height: 100vh;
  padding: 16px 20px 12px;
  background: #ffffff;
  color: #222;
  overflow-x: hidden;
}

.content-wrap {
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
}

.header {
  padding: 4px 0 12px;
}

.header h2 {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
}

.header-subtitle {
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #6b7280;
}

.intro {
  display: flex;
  min-height: calc(100vh - 120px);
  flex-direction: column;
  align-items: stretch;
  padding-top: 16px;
}

.prompt-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin: 0;
}

.prompt-card {
  display: flex;
  min-height: 56px;
  align-items: flex-start;
  justify-content: flex-start;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  padding: 12px 16px;
  color: #111827;
  font-size: 13.5px;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.prompt-card:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  transform: translateY(-1px);
}

.intro-title {
  margin: 40px 0 12px;
  color: #2b2b2b;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}

.chat {
  margin-top: 14px;
  min-height: 40vh;
  border: 1px solid #d9d9e3;
  border-radius: 14px;
  background: #fff;
  padding: 16px;
}

.chat-inner {
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.composer {
  transition: all 0.35s ease;
}

.welcome-composer {
  margin-top: 40px;
}

.chat-composer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  padding-top: 16px;
  padding-bottom: 8px;
  margin-top: 12px;
  background: linear-gradient(to top, #ffffff 75%, rgba(255, 255, 255, 0));
}

.chat-composer .row {
  width: 100%;
  margin: 0;
}

.row {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}

input {
  flex: 1 1 auto;
  width: 0;
  min-width: 0;
  border: 1px solid #d1d5db;
  border-radius: 20px;
  background: #fff;
  padding: 14px 18px;
  font-size: 15px;
  height: 42px;
  outline: none;
}

input:focus {
  border-color: #2f80ed;
}

button {
  flex: 0 0 220px;
  width: 220px;
  height: 42px;
  line-height: 0px;
  border: none;
  border-radius: 18px;
  background: #2f80ed;
  padding: 14px 18px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

button:hover {
  background: #1c5fcc;
}

button:disabled {
  opacity: 0.6;
  cursor: default;
}

.msg {
  display: flex;
  margin: 12px 0;
  width: 100%;
}

.user-msg {
  justify-content: flex-end;
}

.assistant-msg {
  justify-content: flex-start;
}

.user-msg {
  display: flex;
  justify-content: flex-end;
}

.user-bubble {
  max-width: 70%;
/*   border-radius: 20px 20px 4px 20px; */
  border-radius: 20px;
/*   background: #2f80ed; */
  background: #ececec;
/*   color: #fff; */
  color: rgb(34, 34, 34);
  padding: 12px 16px;
  word-break: break-word;
  text-align: left;
}

.assistant-msg {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.assistant-content {
  width: 100%;
  max-width: 100%;
/*   background: #f3f4f6; */
  border-radius: 20px 20px 20px 4px;
  padding: 12px 16px;
  word-break: break-word;
}

.assistant-content ::v-deep p {
  margin: 0 0 12px;
}

.assistant-content ::v-deep ul,
.assistant-content ::v-deep ol {
  margin: 8px 0 14px 28px;
  padding-left: 14px;
}

.assistant-content ::v-deep li {
  margin: 6px 0;
}

.assistant-content ::v-deep hr {
  margin: 16px 0;
  border: none;
  border-top: 1px solid #e5e5e5;
}

.assistant-content ::v-deep img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 18px 0;
  border-radius: 10px;
}

.assistant-content ::v-deep table {
  width: 100%;
  margin: 14px 0 18px;
  border-collapse: collapse;
  background: #fff;
  font-size: 14px;
}

.assistant-content ::v-deep thead {
  background: #f3f4f6;
}

.assistant-content ::v-deep th,
.assistant-content ::v-deep td {
  border: 1px solid #dfe3e8;
  padding: 10px 12px;
  text-align: left;
  vertical-align: top;
}

.assistant-content ::v-deep th {
  font-weight: 700;
}

.assistant-content ::v-deep tbody tr:nth-child(even) {
  background: #fafafa;
}

.typing {
  color: #777;
  font-style: italic;
}

@media (max-width: 700px) {
  .gpt-page {
    padding: 10px;
  }

  .content-wrap {
    max-width: 100%;
  }

  .header h2 {
    font-size: 20px;
  }

  .header-subtitle {
    margin-bottom: 8px;
    font-size: 14px;
  }

  .intro {
    min-height: calc(100vh - 90px);
    padding-top: 24px;
  }

  .prompt-cards {
    grid-template-columns: 1fr;
  }

  .prompt-card {
    min-height: auto;
  }

  .intro-title {
    margin: 32px 0 12px;
    font-size: 20px;
  }

  .chat {
    min-height: 40vh;
    padding: 14px 14px 20px;
  }

  .user-bubble,
  .assistant-content {
    max-width: 100%;
  }

  .row {
    gap: 8px;
  }

  input {
    padding: 12px 16px;
  }

  button {
    padding: 12px 14px;
  }

  .assistant-content ::v-deep table {
    font-size: 13px;
  }

  .assistant-content ::v-deep th,
  .assistant-content ::v-deep td {
    padding: 8px 9px;
  }
}
</style>
